var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"page-bridge",class:_vm.className,style:({
		transform: `translateY(${_vm.translateY}%)`, // 5 sections
	})},[_c('div',{staticClass:"character-container"},[_c('ViewConversationCharacters')],1),_c('div',{staticClass:"dialogue-container"},[_c('ViewConversationDialogue',{staticClass:"use-opposite",attrs:{"interactionModel":this.interactionModel},on:{"complete":_vm.Handle_OnDialogueComplete}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }